// extracted by mini-css-extract-plugin
export default {"ctn":"fade-in-text-effect_ctn__cTPLP","renderElement":"fade-in-text-effect_renderElement__q0X+l","putElement":"fade-in-text-effect_putElement__cBGIU"};